<template>
        <form action="/quiz" class="kce-quiz-form" id="kce-quiz" method="POST">
            <div class="kce-container">
                <div class="kce-video" id="fs-element">
                    <!-- <iframe id="player" class="quiz-video-player" :src="quizVideo" :title="quizVideoTitle" frameborder="0" allow="allowfullscreen"></iframe> -->
                <youtube :video-id="quizVideo"
                     @ended="ended"
                     :player-vars="{ controls: 0, 'cc_load_policy': 1, allowfullscreen: 'allowfullscreen'}"
                ></youtube>
                <button class="kce-fullscreen__toggle" type="button" aria-label="Toggle Fullscreen Video" @click="gofullscreen"></button>
                </div>
                
            </div>
             <div class="kce-container">
            <h2 class="kce__header">{{quizHeader}}</h2>
            </div>
            <div  v-if="ready==true" class="quiz-questions" v-for="(question, index) in quizQuestions">
                <div class="kce-container">
                    <fieldset class="question-wrapper">
                        <legend>
                            <span class="quiz-question">{{question.question}}</span>
                        </legend>
                        <div class="fieldset-wrapper" v-for="(answer, index) in question.answers">
                                <div
                                    class="form-item form-group">
                                    <input type="radio" :id="question.questionID+'answer'+index" :name="question.question"
                                        :value="answer" class="form-radio form-control">

                                    <label :for="question.questionID+'answer'+index" class="option">{{answer}}</label>
                                </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <button :disabled="!ready" type="submit"  class="kce-btn-secondary" @click="(e)=>{onSubmit(e)}" >SUBMIT</button>
             <KceQuizPopup v-if="showResults==true" :clear-form-data="clearFormData" :result-status="resultStatus" :quiz-header="quizHeader" :result-questions="resultQuestions" :show-results="showResults" :get-data="getData" :step-tracker="this.$props.stepTracker" @updated="(value)=>{this.ready=value}"></KceQuizPopup>
        </form>
</template>
<script>
import { numeric } from '@vuelidate/validators';
import KceQuizPopup from './KceQuizPopup.vue';

    export default {
         props:{
            quizHeader:String,
            quizVideo:String,
            quizVideoTitle:String,
            quizStep:Number,
            quizQuestions: Array,
            getData: Function, 
            stepTracker:Number
         },
    components: {
        KceQuizPopup
    },
    data() {
        return {
            selectedOption: [],
            resultStatus: "",
            resultQuestions: [],
            showResults:false,
            incorrectCounter: 0,
            ready: false
        };
    },
    mounted() {
    },
    beforeDestroy() { },
    methods: {
        // {
        //     this.$props.getData();
        //    // return this.showResults = e;
        // },
        gofullscreen(){
            let fs_element = $("#fs-element")[0];
            if(!document.fullscreenElement){
                fs_element.requestFullscreen();
            }else if (document.exitFullscreen){
                document.exitFullscreen();s
            }
        },
        clearFormData(){
            $("#kce-quiz")[0].reset();
            this.resultQuestions = [];
            this.incorrectCounter = 0;
            this.showResults = false;
        },
        onSubmit(e){
             e.preventDefault();
            this.showResults = true;
            let buttons = $("[type='radio']:checked");
            $(buttons).each((index, button) => {
                let currentQuestion = this.$props.quizQuestions.filter(question => question.question === button.name)[0];
                let currentAnswer = button.value
                let correctAnswer = currentQuestion.correctAnswer;
                let answerData = 
                {"question":currentQuestion.question,
                  "answer":currentAnswer,
                  "correctAnswer":correctAnswer
                }
                this.resultQuestions.push(answerData);
                if (currentAnswer != correctAnswer) this.incorrectCounter+=1;
                console.log(answerData)
            });
            if (buttons.length < 3){this.resultStatus = "notFilledOut"} 
            else if (this.incorrectCounter > 1){this.resultStatus = "failed"}
            else {this.resultStatus = "passed"};
        },
        ended(){
            console.log("ended");
            this.ready = true;
        }
    },
    computed: {
    }
}

</script>
<style scoped>
    
</style>